module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view view-ar"
  }, [(_vm.showingPhotoId !== null) ? _c('single-feed', {
    attrs: {
      "photoid": _vm.showingPhotoId
    },
    on: {
      "close": function($event) {
        _vm.showingPhotoId = null
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0px",
      "left": "0px",
      "z-index": "999",
      "width": "100%"
    }
  }, [(_vm.infotext !== '') ? _c('infobox', {
    attrs: {
      "text": _vm.infotext
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ar"
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "argon"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "argon-canvas"
    },
    on: {
      "click": _vm.clickHandler
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera",
    attrs: {
      "id": "camera"
    }
  }, [_c('video', {
    attrs: {
      "id": "camera-video",
      "autoplay": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbf76708"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arex.vue
// module id = 119
// module chunks = 0